import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Main = styled.div.withConfig({
  displayName: "Main",
  componentId: "sc-1sqhol2-0"
})(["display:flex;flex-direction:column;min-height:100vh;padding-top:", ";background-color:", ";font-family:", ";", ";color:", ";@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){display:block;}", ";"], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.navHeight, "px");
}, function (_ref2) {
  var theme = _ref2.theme,
    grey = _ref2.grey;
  return grey ? theme.colors.uiLL : theme.colors.background;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.bodyFontFamily;
}, getFont(0), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.font;
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-top: ", ";\n  "])), function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.mobileNavHeight, "px");
}));